// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Button loading animation spinner */

.spinner {
  margin: 0px auto 0;
  width: 70px;
  text-align: center;
}
.spinner-colorful > div {
  background: linear-gradient(-90deg, #073649 0%, #457489 100%) !important;
  background: -webkit-linear-gradient(-90deg, #073649 0%, #457489 100%) !important;
}
.spinner > div {
  width: 11px;
  height: 11px;
  background-color: #fff;
  margin-right: 5px;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

/* Override the react-datepicker styles */

.react-datepicker-wrapper {
  width: 100%;
}
.react-datepicker__day--selected,
.react-datepicker__day--in-range {
  background: #748d6f !important;
  border-radius: 0px;
}

.react-datepicker__current-month {
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 20px;
  color: #748d6f;
}

.react-datepicker__header {
  background: #fff;
  border: none;
}

.react-datepicker {
  font-family: 'Montserrat', sans-serif;
  border-radius: 0px;
  border: 1px solid #ededed;
}
.react-datepicker__navigation--previous,
.react-datepicker__navigation--next {
  border-right-color: #748d6f;
  background-color: #eef4ea;
}
.react-datepicker__navigation--previous {
  left: 12px;
}
.react-datepicker__navigation--next {
  right: 12px;
}

.react-datepicker__navigation-icon--previous::before {
  right: -4px;
}
.react-datepicker__navigation-icon--next::before {
  left: -3px;
}
.react-datepicker__day,
.react-datepicker__day-name {
  margin: 0.37rem;
}
.react-datepicker__day-name {
  font-weight: 600;
}
.react-datepicker__day--in-selecting-range {
  background: #becbbb !important;
}
.react-datepicker__navigation-icon::before {
  border-color: #748d6f;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: '';
  display: block;
  height: 9px;
  position: absolute;
  top: 11px;
  width: 9px;
}
.react-datepicker__day--outside-month {
  color: #93a68f;
}

[data-slate-placeholder='true'] {
  width: 93% !important;
}

.react-datepicker__month-text {
  font-size: 0.9rem;
  font-weight: 500;
}
.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
  display: inline-block;
  width: 5rem;
  margin: 5px;
  padding: 7px;
}

.react-datepicker__month-text.react-datepicker__month--selected:hover,
.react-datepicker__month-text.react-datepicker__month--in-range:hover,
.react-datepicker__month-text.react-datepicker__quarter--selected:hover,
.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__month--selected:hover,
.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {
  background: #748d6f;
  color: #fff;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background: #748d6f;
  color: #fff;
}

.map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.react-datepicker__time-container {
  width: 150px;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 100%;
}

.react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--selected {
  background-color: #748d6f;
}

.react-datepicker__month--selected,
.react-datepicker__month--in-selecting-range,
.react-datepicker__month--in-range,
.react-datepicker__quarter--selected,
.react-datepicker__quarter--in-selecting-range,
.react-datepicker__quarter--in-range {
  background-color: #748d6f;
}

.react-datepicker__header__dropdown .react-datepicker__header__dropdown--select {
  margin-top: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,wEAAwE;EACxE,gFAAgF;AAClF;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EAErB,wDAAwD;AAC1D;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;EAEE,uBAAuB;AACzB;;AAaA;EACE;;;IAIE,mBAAmB;EACrB;EACA;IAEE,mBAAmB;EACrB;AACF;;AAEA,yCAAyC;;AAEzC;EACE,WAAW;AACb;AACA;;EAEE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;EAEE,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;;EAEE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;EAQE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;EAIE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Button loading animation spinner */\n\n.spinner {\n  margin: 0px auto 0;\n  width: 70px;\n  text-align: center;\n}\n.spinner-colorful > div {\n  background: linear-gradient(-90deg, #073649 0%, #457489 100%) !important;\n  background: -webkit-linear-gradient(-90deg, #073649 0%, #457489 100%) !important;\n}\n.spinner > div {\n  width: 11px;\n  height: 11px;\n  background-color: #fff;\n  margin-right: 5px;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.spinner .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.spinner .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes sk-bouncedelay {\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n/* Override the react-datepicker styles */\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n.react-datepicker__day--selected,\n.react-datepicker__day--in-range {\n  background: #748d6f !important;\n  border-radius: 0px;\n}\n\n.react-datepicker__current-month {\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin-bottom: 20px;\n  color: #748d6f;\n}\n\n.react-datepicker__header {\n  background: #fff;\n  border: none;\n}\n\n.react-datepicker {\n  font-family: 'Montserrat', sans-serif;\n  border-radius: 0px;\n  border: 1px solid #ededed;\n}\n.react-datepicker__navigation--previous,\n.react-datepicker__navigation--next {\n  border-right-color: #748d6f;\n  background-color: #eef4ea;\n}\n.react-datepicker__navigation--previous {\n  left: 12px;\n}\n.react-datepicker__navigation--next {\n  right: 12px;\n}\n\n.react-datepicker__navigation-icon--previous::before {\n  right: -4px;\n}\n.react-datepicker__navigation-icon--next::before {\n  left: -3px;\n}\n.react-datepicker__day,\n.react-datepicker__day-name {\n  margin: 0.37rem;\n}\n.react-datepicker__day-name {\n  font-weight: 600;\n}\n.react-datepicker__day--in-selecting-range {\n  background: #becbbb !important;\n}\n.react-datepicker__navigation-icon::before {\n  border-color: #748d6f;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: '';\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 11px;\n  width: 9px;\n}\n.react-datepicker__day--outside-month {\n  color: #93a68f;\n}\n\n[data-slate-placeholder='true'] {\n  width: 93% !important;\n}\n\n.react-datepicker__month-text {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 5rem;\n  margin: 5px;\n  padding: 7px;\n}\n\n.react-datepicker__month-text.react-datepicker__month--selected:hover,\n.react-datepicker__month-text.react-datepicker__month--in-range:hover,\n.react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n  background: #748d6f;\n  color: #fff;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  background: #748d6f;\n  color: #fff;\n}\n\n.map-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.react-datepicker__time-container {\n  width: 150px;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 100%;\n}\n\n.react-datepicker__time-container\n  .react-datepicker__time\n  .react-datepicker__time-box\n  ul.react-datepicker__time-list\n  li.react-datepicker__time-list-item--selected {\n  background-color: #748d6f;\n}\n\n.react-datepicker__month--selected,\n.react-datepicker__month--in-selecting-range,\n.react-datepicker__month--in-range,\n.react-datepicker__quarter--selected,\n.react-datepicker__quarter--in-selecting-range,\n.react-datepicker__quarter--in-range {\n  background-color: #748d6f;\n}\n\n.react-datepicker__header__dropdown .react-datepicker__header__dropdown--select {\n  margin-top: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
